// metaPixel.js
// Meta Pixel del sitio. #added 2/11/26 TG
//
// Sin metaPixelId en config.js esto no hace nada: ni carga el script de Meta.
//
// Reglas:
// - El pixel manda la URL completa a Meta, y la vuelta de Tilopay trae email,
//   nombre y teléfono en la URL. Por eso NUNCA corre en /payment-complete ni en
//   la primera página después de esa (el referrer también trae la URL).
// - Purchase NO sale de aquí: lo manda el servidor (php/meta-capi.php), solo
//   cuando el pago es real.
// - Igual que el analytics: si falla, la página sigue como si nada. TG

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { metaPixelId } from "./config";
import { isMarkedAsOwner } from "./useAnalytics";

const BLOCKED_PATHS = /^\/(payment-complete|bank-transfer|admin|product-manager)/i;

const allowed = () => {
  if (!metaPixelId) return false;
  if (isMarkedAsOwner()) return false; // mis visitas no entrenan los anuncios
  if (BLOCKED_PATHS.test(window.location.pathname)) return false;
  return !/payment-complete|returnData/i.test(document.referrer || "");
};

// El código base de Meta, escrito legible. autoConfig apagado para que no lea
// formularios, y disablePushState para mandar el PageView nosotros. TG
const loadPixel = () => {
  if (window.fbq) return;
  const fbq = function () {
    if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
    else fbq.queue.push(arguments);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  fbq.disablePushState = true;
  fbq.allowDuplicatePageViews = true; // #added sin esto Meta ignora los PageView después de la primera página 3/11/26 TG
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  window.fbq("set", "autoConfig", false, metaPixelId);
  window.fbq("init", metaPixelId);
};

export const metaEvent = (name, data) => {
  try {
    if (!allowed()) return;
    loadPixel();
    if (data) window.fbq("track", name, data);
    else window.fbq("track", name);
  } catch (e) {
    /* silencio */
  }
};

// Lo que Meta necesita saber de un producto del carrito. Sin datos personales. TG
export const metaProduct = (product, language) => {
  const gtq = language !== "en" && parseFloat(product?.pricegtq) > 0;
  return {
    content_type: "product",
    content_ids: [String(product?.id ?? product?.product_id ?? "")],
    content_name: product?.name || "",
    value: parseFloat(gtq ? product?.pricegtq : product?.price) || 0,
    currency: gtq ? "GTQ" : "USD",
  };
};

// ------------------------------------------------------------
// #MetaPixelTracker
// Va después de <AnalyticsTracker /> porque ese lee la marca de owner. TG
// ------------------------------------------------------------
const MetaPixelTracker = () => {
  const location = useLocation();
  const lastPath = useRef(null); // mismo candado de StrictMode que el analytics

  useEffect(() => {
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    metaEvent("PageView");
  }, [location]);

  return null;
};

export default MetaPixelTracker;
